import { render, staticRenderFns } from "./RowDetails.vue?vue&type=template&id=0700c826&scoped=true"
import script from "./RowDetails.vue?vue&type=script&lang=js"
export * from "./RowDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0700c826",
  null
  
)

export default component.exports